import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login'
import register from '@/views/register'
import NotFound from '@/views/404'
import home from '@/views/home'
Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  }
]


export default new Router({
  mode: "history",
  routes: constantRouterMap
});

export const asyncRouterMap = [
  {
    path: '/index',
    name: 'index',
    component: index,
    meta:{
      title: '首页',
      icon: 'el-icon-s-home',
    },
    children: [
      {
        path: "/",
        name: 'home',
        meta:{
          title: 'home',
          icon: '',
        },
        component: home,
      }
    ]
  },{
    path: "*",
    name: '404',
    meta:{
      title: '404'
    },
    component: NotFound,
  }
]










// WEBPACK FOOTER //
// ./src/router/index.js